import { QueryClient } from 'react-query';
import { campaignGroupsQueryKey } from './campaignGroups';

/**
 * Invalidate every query derived from the customer's uploaded data.
 *
 * Uploaded files define the campaigns (and their IDs) and the KPI columns.
 * These queries cache for 12h (DATA_QUERY_EXPIRATION), so after an upload or
 * a full data deletion the model forms would otherwise keep operating on
 * stale campaign IDs — submitting campaigns that no longer exist and failing
 * backend validation ("Selected campaigns don't have these media sources
 * configured").
 */
export const invalidateCustomerDataQueries = (
  queryClient: QueryClient,
  customer: string,
): void => {
  queryClient.invalidateQueries(['useCampaignMappingsQuery', customer]);
  queryClient.invalidateQueries(['useCampaignMappingsColumnsQuery', customer]);
  queryClient.invalidateQueries(campaignGroupsQueryKey(customer));
  queryClient.invalidateQueries(['kpiSources', customer]);
};
